import { useQuery } from "@tanstack/react-query";
import { getLeaveRequestsByID } from "src/redux/api/_hr_attendance.api";
import { LeaveRequest } from "src/redux/types/_attendance.type";

export const leaveByIdKeys = {
  all: ["hr-leaves-by-id"] as const,
  list: (employeeId: number) => [...leaveByIdKeys.all, "list", employeeId] as const,
  update: (id: string) => [...leaveByIdKeys.all, "update", id] as const,
};

export const useLeavesById = ({employeeId}: {employeeId: number}) => {
  return useQuery<LeaveRequest[]>({
    queryKey: leaveByIdKeys.list(employeeId),
    queryFn: () => getLeaveRequestsByID(employeeId),
    enabled: !!employeeId,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60,
  });
};
